import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';
import { Store } from '@ngrx/store';
import { iif, Observable, of, combineLatest } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { getSeoInfo } from '../../store/category-page.selectors';

import { CategorySeoService } from './category-seo.service';

import { Category } from '@core/domain/models/category.models';
import { SeoInfo } from '@core/domain/models/seo.models';
import { SeoSelectors } from '@features/seo';
import { Resolutions } from '@layout/domain/models/layout.models';
import { getResolution } from '@layout/infrastructure/state/layout.selectors';
import { GoToSection } from '@shared/navigation';

@Component({
    selector: 'category-seo',
    templateUrl: './category-seo.component.html',
    providers: [CategorySeoService],
})

/**
 * Componente para mostrar bloques de SEO en parrillas
 */
export class CategorySeoComponent implements OnInit {
    public seoInfo$: Observable<SeoInfo> = this.store.select(getSeoInfo);

    public seoInfoForRender$: Observable<SeoInfo>;

    public relatedCategories$: Observable<Category[]>;

    public seoInfoForFilteredCategories$: Observable<SeoInfo>;

    public lastSectionTranslated$: Observable<string> = this.store.select(SeoSelectors.getLastSectionTranslated);

    public isMobile$: Observable<boolean> = this.store.select(getResolution)
        .pipe(map((resolutions: Resolutions) => resolutions === Resolutions.MOBILE));

    public domHasNoindex = !!this.meta.getTag('name="robots"');

    constructor(
        private readonly store: Store,
        private readonly route: ActivatedRoute,
        private readonly categorySeoService: CategorySeoService,
        private readonly meta: Meta
    ) { }

    public ngOnInit(): void {
        // Obtenemos los datos de SEO para renderizar el bloque de texto
        this.seoInfoForRender$ = combineLatest([
            this.seoInfo$,
            this.route.queryParams,
        ]).pipe(
            mergeMap(([seoInfo, urlParams]: [SeoInfo, Params]) =>
                iif(
                    () =>
                        urlParams.g,
                    this.categorySeoService.getseoInfoForFilteredCategories(seoInfo, urlParams),
                    of(seoInfo)
                )),
        );

        // Obtenemos las categorias relacionadas
        this.relatedCategories$ = this.categorySeoService.getRelatedCategories();
    }

    /**
     * Función para cambiar el filtro de la parrilla
     */
    public changeCategoryFilter(event: Event, pageUrl: string): void {
        event.preventDefault();

        this.store.dispatch(GoToSection({ url: pageUrl, reload: true }));
    }
}
